import _isEmpty from 'lodash/isEmpty';
import _isNil from 'lodash/isNil';

import {
  FRONT_CHAT_SCRIPT_URL,
  FRONT_CHAT_SCRIPT_ID,
  DEFAULT_USE_LAUNCHER,
} from './FrontChat.constants';

export function frontChatAvailable() {
  return typeof window.FrontChat !== 'undefined';
}

export function frontChatOpen() {
  if (frontChatAvailable()) {
    window.FrontChat('show');
  }
}

export function frontChatClose() {
  if (frontChatAvailable()) {
    window.FrontChat('hide');
  }
}

export function createFrontChatScript({ onLoad = () => null, chatId, nonce = null } = {}) {
  if (document.getElementById(FRONT_CHAT_SCRIPT_ID)) {
    if (onLoad) onLoad();
    return;
  }

  const bundleScript = document.createElement('script');
  bundleScript.id = FRONT_CHAT_SCRIPT_ID;
  bundleScript.src = FRONT_CHAT_SCRIPT_URL;

  if (nonce) {
    bundleScript.nonce = nonce;
  }

  bundleScript.onload = () => {
    const initScript = document.createElement('script');

    if (nonce) {
      initScript.nonce = nonce;
    }

    const initOptions = {
      chatId,
      useDefaultLauncher: DEFAULT_USE_LAUNCHER,
      ...(nonce && { nonce }),
    };

    initScript.innerHTML = `window.FrontChat('init', ${JSON.stringify(initOptions)});`;

    document.body.appendChild(initScript);

    if (onLoad) onLoad();
  };

  bundleScript.onerror = () => {
    // eslint-disable-next-line no-console
    console.error('Failed to load Front Chat script');
  };

  document.body.appendChild(bundleScript);
}

export function frontChatIdentify(user = {}, business = {}) {
  if (frontChatAvailable()) {
    const {
      id: userId,
      email,
      firstName = '',
      lastName = '',
      phoneNumber = '',
      groups = [],
    } = user;

    if (!_isNil(userId) && !_isEmpty(email)) {
      const payload = {
        email,
        name: `${firstName} ${lastName}`.trim(),
        phone: phoneNumber,
        userHash: null,
      };

      if (!_isEmpty(business)) {
        const { id: businessId, name: businessName, type: businessType } = business;
        payload.customFields = {
          business_id: businessId,
          business_type: businessType,
          business_name: businessName,
          user_groups: groups ? groups.toString() : '',
        };

        const { website = {} } = business;
        if (!_isEmpty(website)) {
          const { id: websiteId, cloudformationStackName } = website;
          payload.customFields = {
            ...payload.customFields,
            website_id: websiteId,
            cloudformation_stack_name: cloudformationStackName,
          };
        }
      }

      window.FrontChat('identity', payload);
    }
  }
}

export function frontChatReset() {
  if (frontChatAvailable()) {
    window.FrontChat('reset');
  }
}

export function frontChatUpdateUser(userData) {
  if (frontChatAvailable()) {
    window.FrontChat('updateUser', userData);
  }
}
